import { NgModule } from '@angular/core';
import { StopPropagationDirective } from './stop-propagation/stop-propagation.directive';
import { AutofocusDirective } from "./auto-focus/auto-focus"
import { FreeDraggableDirective } from './free-draggable.directive';
import { VideoReplicateControlsDirective } from './video-replciate-controls.directive';
import { FullscreenWatcherDirective  } from './watch-full-screen';
import { FullScreenVideoPlayerComponentModule } from 'src/app/components/full-screen-video-player/full-screen-video-player.module';
import { FullScreenMediaModule } from 'src/app/modals/full-screen-media/full-screen-media.module';
import { BrandingBackgroundDirective } from './branding/branding-background.directive';
import { IonAutoscrollDirective } from './ion-auto-scroll/ion-auto-scroll.directive';
import { HorizontalScrollDirective } from './horizontal-scroll.directive'
import { AutoResizeDirective } from './auto-resize.directive';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [
    FullScreenVideoPlayerComponentModule,
    FullScreenMediaModule,
    IonicModule
  ],
  declarations: [
    StopPropagationDirective, 
    AutofocusDirective,
    FreeDraggableDirective,
    VideoReplicateControlsDirective,
    FullscreenWatcherDirective,
    BrandingBackgroundDirective,
    IonAutoscrollDirective,
    HorizontalScrollDirective,
    AutoResizeDirective
  ],
  exports: [
    StopPropagationDirective,
    AutofocusDirective,
    FreeDraggableDirective,
    VideoReplicateControlsDirective,
    FullscreenWatcherDirective,
    BrandingBackgroundDirective,
    IonAutoscrollDirective,
    HorizontalScrollDirective,
    AutoResizeDirective
  ]
})
export class DirectivesModule { }